import { Helmet } from 'react-helmet'
import { useState, useEffect } from 'react'

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Container from 'react-bootstrap/Container'
import DepartmentBuilder from '../../Components/Planner/Daily/DepartmentBuilder'
import RoleBuilder from '../../Components/Planner/Daily/RoleBuilder'
import StaffBuilder from '../../Components/Planner/Daily/StaffBuilder'
import CapsuleBuilder from '../../Components/Planner/Daily/CapsuleBuilder'
import PositionBuilder from '../../Components/Planner/Daily/PositionBuilder'
import PlanBuilder from '../../Components/Planner/Daily/PlanBuilder'
import Schedule from '../../Components/Planner/Daily/Schedule'

import { backendAccessGet } from '../../Utils/Authentication'

var menu_bar = [
    {name:'Staff', value:'staff'},
    {name:'Departments', value:'departments'},
    {name:'Positions', value:'positions'},
    {name:'Planner', value:'planner'}
]

export function MenuButton( props )
{
    const name = props.name
    const value = props.value
    const selected = props.selected
    const setSelected = props.setSelected

    return(
        <div className="d-flex justify-content-center align-items-center" 
             style={{ height:'50px', width:'100%', backgroundColor: ( selected == value ) ? "#FFBF00" : "#A7C7E7",
                      borderRadius:'10px', marginBottom:'5px'}}
             onClick={ e => setSelected(value) } >
            <b>{name}</b>
        </div>
    )
}

export default function DailyPlanner( props )
{ 
    const [ activeKey, setActiveKey ] = useState("roles")

    return (
        <>
            <Helmet>
                <title> Manager | Daily Planner </title>
            </Helmet>

            <Container style={{ height:'calc(100vh - 60px)', maxWidth:'1200px', padding:'10px', overflowY:'scroll'}}> 
                <Tabs activeKey={activeKey} onSelect={(k) => setActiveKey(k)} justify>
                    {/*<Tab eventKey="staff" title="Staff Mapper">
                        <StaffMapper staffOld={staffOld} staff={staff} />
                    </Tab>*/}
                    {/*<Tab eventKey="departments" title="Departments">
                        <DepartmentBuilder activeKey={activeKey}/>
                    </Tab>*/}

                    {/*
                    <Tab eventKey="roles" title="Roles">
                        <RoleBuilder activeKey={activeKey}/>
                    </Tab>
                    <Tab eventKey="staff" title="Staff">
                        <StaffBuilder activeKey={activeKey}/>
                    </Tab>
                    <Tab eventKey="departments" title="Departments">
                        <DepartmentBuilder activeKey={activeKey}/>
                    </Tab>
                    */}


                    {/*<Tab eventKey="capsules" title="Capsules">
                        <CapsuleBuilder activeKey={activeKey} />
                    </Tab>*/}
                    {/*<Tab eventKey="schedule" title="Schedule">
                        <Schedule activeKey={activeKey}/>
                    </Tab>*/}
                    {/*<Tab eventKey="positions" title="Positions">
                        { (positions.arrangment != null && positions.positions != null ) && 
                        <PositionBuilder positions={positions} setPositions={setPositions}
                                         departments={departments} setDepartments={setDepartments}
                                         staff={staff} setStaff={setStaff}
                        />
                        }
                    </Tab>*/}
                    {/*<Tab eventKey="planner" title="Planner">
                        <PlanBuilder activeKey={activeKey} />
                    </Tab>*/}
                </Tabs>
            </Container>
        </>
    )
}
